module.exports = __webpack_public_path__ + "media/assets/community/x-mark-cf9b88abc5ce20b9a571617120558255e469d1d41ebbe04709ca4e0440e333c9.png";